import React from "react";

import type { PayrollSectionContent } from "../content/types";

type PayrollSectionProps = {
  content: PayrollSectionContent;
};

export function PayrollSection({ content }: PayrollSectionProps) {
  return (
    <section className="db-section section-band payroll-section" id={content.id} aria-labelledby={`${content.id}-title`}>
      <div className="db-container payroll-section__inner">
        <div className="section-heading payroll-section__heading">
          <p className="section-eyebrow">{content.eyebrow}</p>
          <h2 id={`${content.id}-title`}>{content.title}</h2>
          <p>{content.lead}</p>
        </div>

        <div className="payroll-workflow-grid" aria-label={content.title}>
          {content.workflows.map((item, index) => (
            <article className="payroll-workflow-card" data-payroll-card={item.id} key={item.id}>
              <div className="payroll-workflow-card__visual" aria-hidden="true">
                <img src={`/assets/dynamicbooks-v3/${item.assetId}.svg`} alt="" loading="lazy" />
              </div>
              <div className="payroll-workflow-card__copy">
                <span className="payroll-workflow-card__step">{String(index + 1).padStart(2, "0")}</span>
                <h3>{item.title}</h3>
                <p>{item.body}</p>
                <p className="payroll-workflow-card__detail">{item.detail}</p>
              </div>
            </article>
          ))}
        </div>

        <div className="payroll-boundary" data-payroll-boundary>
          <p>{content.boundary}</p>
          <p>{content.tierNote}</p>
        </div>
      </div>
    </section>
  );
}
